module.exports = __webpack_public_path__ + "img/dark-mud-decal-02.81950eca.png";